
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PhotoField } from "./fields/PhotoField";
import { CurrencyInput } from "@/components/ui/currency-input";

interface ProductFormValues {
  title: string;
  description: string;
  price: number;
  condition: string;
  address: string;
  phone: string;
  photo?: File;
  currency: string;
}

interface ProductFormFieldsProps {
  form: UseFormReturn<ProductFormValues>;
}

export const ProductFormFields = ({ form }: ProductFormFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom du produit</FormLabel>
            <FormControl>
              <Input required {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <div className="grid grid-cols-1 gap-4">
        <FormField
          control={form.control}
          name="price"
          render={({ field: priceField }) => (
            <FormItem>
              <FormLabel>Prix</FormLabel>
              <FormControl>
                <CurrencyInput
                  value={priceField.value || 0}
                  onChange={(value) => form.setValue("price", value)}
                  currency={form.watch("currency") || "EUR"}
                  onCurrencyChange={(value) => form.setValue("currency", value)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="condition"
        render={({ field }) => (
          <FormItem>
            <FormLabel>État du produit</FormLabel>
            <Select 
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value || ""}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Sélectionnez l'état du produit" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="new">Neuf</SelectItem>
                <SelectItem value="like-new">Comme neuf</SelectItem>
                <SelectItem value="good">Bon état</SelectItem>
                <SelectItem value="used">Utilisé</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Adresse de retrait/livraison</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Téléphone de contact</FormLabel>
            <FormControl>
              <Input type="tel" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <PhotoField form={form} name="photo" label="Photo du produit" />
    </>
  );
};
